import Hero from "@/components/ui/Hero";
import CTABlock from "@/components/ui/CTABlock";
import OwnerPhoto from "@/components/ui/OwnerPhoto";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function About() {
    useDocumentTitle(
        "About A1 Screening · Family-Owned in Naples, FL Since 1999",
        "A1 Screening is a family-owned pool cage and screen repair company based in Naples, FL. Serving Southwest Florida since 1999. Free estimates."
    );
    return (
        <>
            <Hero
                eyebrow="About"
                title="Family-Owned. Naples-Based. Since 1999."
                subtitle="A1 Screening is a family-owned pool cage and screen repair company serving Naples and Southwest Florida. We answer the phone, show up on time, and finish the job clean."
            />
            <section className="a1-section">
                <div className="a1-container grid md:grid-cols-12 gap-10 items-start max-w-5xl">
                    <div className="md:col-span-5">
                        <OwnerPhoto
                            variant="rounded"
                            aspectClass="aspect-[4/5]"
                            testId="owner-photo-about"
                        />
                    </div>
                    <div className="md:col-span-7 space-y-4 text-[var(--color-text)]" data-testid="about-owner-copy">
                        <p className="a1-eyebrow">Owner</p>
                        <h2 className="a1-h2-underline">John Stephens</h2>
                        <p>
                            Owner John Stephens has built A1 Screening around practical screen repair, clear communication, and service across Southwest Florida. The company has served the area since 1999.
                        </p>
                        <p>
                            We've been repairing pool cages, lanais, screen doors, and condo screens across Naples and Southwest Florida since 1999. Twenty-six-plus years of doing this work means we know what holds up in our climate and what doesn't.
                        </p>
                        <p>
                            We don't run a call center. When you call <a href="tel:+12394347306">239-434-7306</a>, you reach a Naples-based team that actually does the work.
                        </p>
                        <p className="serif italic text-lg">"From pool cages to condos, we screen it all."</p>
                    </div>
                </div>
            </section>
            <CTABlock />
        </>
    );
}
